import React from "react";
import { LoaderCircle } from "lucide-react";
import { joinClasses } from "../ResultsPrimitives.jsx";

export default function DispatchHeaderMenuSwitch({ checked = false, isBusy = false }) {
  if (isBusy) {
    return (
      <span className="inline-flex w-9 shrink-0 items-center justify-center" aria-live="polite">
        <LoaderCircle aria-hidden="true" className="h-4 w-4 motion-safe:animate-spin motion-reduce:animate-none" />
        <span className="sr-only">Mise à jour…</span>
      </span>
    );
  }

  return (
    <span
      aria-hidden="true"
      className={joinClasses([
        "inline-flex h-5 w-9 shrink-0 items-center rounded-[4px] border p-0.5 transition-colors",
        checked ? "border-accent bg-accent" : "border-slate-300 bg-slate-200",
      ])}
    >
      <span className={joinClasses([
        "h-3.5 w-3.5 rounded-[4px] bg-white shadow-sm motion-safe:transition-transform",
        checked ? "translate-x-4" : "translate-x-0",
      ])} />
    </span>
  );
}
